export default __webpack_public_path__ + "static/media/emailSend.5aed220e.png";